const ChooseFileIcon = (props) => {
    return (
        <svg {...props} width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17.5H9V13.325L10.6 14.925L12 13.5L8 9.5L4 13.5L5.425 14.9L7 13.325V17.5ZM2 20.5C1.45 20.5 0.979167 20.3042 0.5875 19.9125C0.195833 19.5208 0 19.05 0 18.5V2.5C0 1.95 0.195833 1.47917 0.5875 1.0875C0.979167 0.695833 1.45 0.5 2 0.5H10L16 6.5V18.5C16 19.05 15.8042 19.5208 15.4125 19.9125C15.0208 20.3042 14.55 20.5 14 20.5H2ZM9 7.5V2.5H2V18.5H14V7.5H9Z" fill="currentColor" />
        </svg>
    )
}

export default ChooseFileIcon;